/* tslint:disable */

declare var Object: any;
export interface ERPsalesPrepaymentSettlementInterface {
  "id"?: number;
}

export class ERPsalesPrepaymentSettlement implements ERPsalesPrepaymentSettlementInterface {
  "id": number;
  constructor(data?: ERPsalesPrepaymentSettlementInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ERPsalesPrepaymentSettlement`.
   */
  public static getModelName() {
    return "ERPsalesPrepaymentSettlement";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ERPsalesPrepaymentSettlement for dynamic purposes.
  **/
  public static factory(data: ERPsalesPrepaymentSettlementInterface): ERPsalesPrepaymentSettlement{
    return new ERPsalesPrepaymentSettlement(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ERPsalesPrepaymentSettlement',
      plural: 'ERPsalesPrepaymentSettlements',
      path: 'ERPsalesPrepaymentSettlements',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ERPsalesPrepaymentSettlement.ts